/**
 * Mapper for useAvatar to control global useAvatar setting
 * useAvatar -> Market.Competitor
 */

const textSizeExceptions = ["sixpack", "rowgrouped"];
export function mapUseAvatar({
  hasCompetitor, hasCompetitors, market, draftMarket, useAvatar, type
}) {

  const _textSize = textSizeExceptions.includes(type) ? "heading-md" : "body-sm";
  const hasCompetitorWithAvatar = hasCompetitor && "useAvatar" in market?.competitor && market?.competitor?.useAvatar;
  const shouldSkipCompetitorAvatar = !hasCompetitorWithAvatar && !hasCompetitors;
  
  if (shouldSkipCompetitorAvatar) {
    draftMarket.competitor = {
      ...{
        useAvatar,
        avatar: { border: "none", bgColor: "bg-default", ...market.competitor?.avatar },
        textSize: textSizeExceptions.includes(type) ? "heading-md" : "body-sm"
      },
    };
  } else {
    draftMarket.competitor = {
      ...{
        ...draftMarket?.competitor,
        textSize: textSizeExceptions.includes(type) ? "heading-md" : "body-sm"
      },
    };
  }

  if (hasCompetitors) {
    draftMarket?.competitors.forEach(competitor => {
      competitor.textSize = _textSize;
    });
  }
}
